export default function mapVideos(cmsData, appData) {
	if (!appData?.pages?.boltWatchMore) return null;

	const videosData = cmsData?.pages?.videos;
	if (!videosData?.active) return null;
}